<template>
  <div
    v-if="variant === 'spinner'"
    class="ui-progress ui-progress--spinner"
    :aria-label="ariaLabel || 'Загрузка'"
  >
    <span class="ui-progress__spinner" />
  </div>
  <div
    v-else
    class="ui-progress ui-progress--linear"
    :aria-label="ariaLabel || 'Загрузка'"
    role="progressbar"
    :aria-valuenow="indeterminate ? 0 : normalizedValue"
    :aria-valuemin="0"
    :aria-valuemax="100"
  >
    <div class="ui-progress__track">
      <div
        class="ui-progress__bar"
        :class="{ 'ui-progress__bar--indeterminate': indeterminate }"
        :style="indeterminate ? undefined : { width: `${normalizedValue}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    variant?: 'spinner' | 'linear'
    /** 0–100 для linear, игнорируется для spinner */
    value?: number
    indeterminate?: boolean
    ariaLabel?: string
  }>(),
  {
    variant: 'spinner',
    value: 0,
    indeterminate: true,
    ariaLabel: 'Загрузка',
  },
)

const normalizedValue = computed(() => Math.min(100, Math.max(0, props.value)))
</script>

<style scoped>
.ui-progress--spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ui-progress__spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #0f172a;
  border-radius: 50%;
  animation: ui-progress-spin 0.8s linear infinite;
}

.ui-progress--linear {
  width: 100%;
}

.ui-progress__track {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
}

.ui-progress__bar {
  height: 100%;
  background: #0f172a;
  border-radius: 3px;
  transition: width 0.2s ease;
}

.ui-progress__bar--indeterminate {
  width: 30% !important;
  animation: ui-progress-linear 1.2s ease-in-out infinite;
}

@keyframes ui-progress-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes ui-progress-linear {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}
</style>
